<app-student-nav></app-student-nav>

<section class="meetings">
  <div class="meetings-header">
    <h1 class="meetings-page-title">Meetings</h1>
    <mat-form-field class="meetingSearch" appearance="outline" subscriptSizing="dynamic">
      <mat-icon matPrefix>search</mat-icon>
      <input
        matInput
        placeholder="Search meetings..."
        [ngModel]="searchQuery"
        (ngModelChange)="onSearchInput($event)"
        (keydown.escape)="onSearchInput('')"
        aria-label="Search meetings by subject, counselor, or location"
        autocomplete="off"
        data-testid="meetings-search-input"
      />
    </mat-form-field>
    <mat-form-field class="meetingFilter" appearance="outline" subscriptSizing="dynamic">
      <mat-select
        [(ngModel)]="meetingFilter"
        aria-label="Filter meetings by status"
        data-testid="meetings-status-filter"
      >
        @for (option of filters; track option.value) {
          <mat-option [value]="option.value">{{ option.label }}</mat-option>
        }
      </mat-select>
    </mat-form-field>
    <button
      class="new-meeting-btn"
      data-testid="new-meeting-btn"
      mat-flat-button
      color="primary"
      (click)="openRequestMeetingDialog()"
    >
      <mat-icon>add</mat-icon> New meeting
    </button>
  </div>

  @if (filteredMeetings.length) {
    <div class="meeting-list">
      @for (m of filteredMeetings; track m.id) {
        <ng-container *ngTemplateOutlet="meetingCard; context: { $implicit: m }"></ng-container>
      }
    </div>
  } @else {
    <p class="empty" data-testid="meetings-empty">{{ emptyMessage }}</p>
  }
</section>

<app-messaging-widget></app-messaging-widget>

<!-- Meeting -->
<ng-template #meetingCard let-m>
  <mat-card class="meeting-card">
    <div class="meeting-head">
      <div class="meeting-body">
        <div class="meeting-col">
          <span class="col-label">Subject</span>
          <div class="col-content">
            <p class="reason">{{ m.title }}</p>
            <span class="counselor-sub">{{ m.facultyName }}</span>
          </div>
        </div>
        <div class="meeting-col">
          <span class="col-label">When</span>
          <div class="col-content">
            <span class="meeting-date">{{ m.start | date: 'EEE, MMM d' }}</span>
            <span class="meeting-time-sub"
              >{{ m.start | date: 'h:mm' }}–{{ m.end | date: 'h:mm a' }}</span
            >
          </div>
        </div>
        <div class="meeting-col">
          <span class="col-label">Where</span>
          <div class="col-content">
            @if (m.meetingType === 'remote') {
              @if (m.isOver) {
                <span class="meeting-where-type">Online</span>
              } @else {
                <span class="meeting-where-type"
                  ><mat-icon aria-hidden="true">videocam</mat-icon> Remote</span
                >
                @if (m.meetingLocation) {
                  <a [href]="m.meetingLocation" target="_blank" rel="noopener" class="meeting-link"
                    >Join meeting</a
                  >
                } @else {
                  <span class="meeting-where-pending">Link pending</span>
                }
              }
            } @else if (m.meetingType === 'in-person') {
              <span class="meeting-where-type"
                ><mat-icon aria-hidden="true">location_on</mat-icon> In Person</span
              >
              @if (m.meetingLocation) {
                <span class="meeting-where-detail">{{ m.meetingLocation }}</span>
              }
            } @else {
              <span class="meeting-where-pending">—</span>
            }
          </div>
        </div>
        <div class="meeting-col">
          <div class="status-col-header">
            <span class="col-label">Status</span>
          </div>
          <div class="col-content">
            <span class="status" [class]="m.state">{{ m.stateLabel }}</span>
          </div>
        </div>
      </div>
      <div class="details-btn-wrap">
        <button
          type="button"
          class="details-btn"
          (click)="openDetailsDialog(m)"
          [attr.data-testid]="'meeting-details-btn-' + m.id"
        >
          Details
        </button>
        @if (needsAttention(m)) {
          <span class="needs-attention-dot" [attr.data-testid]="'needs-attention-' + m.id"></span>
        }
      </div>
    </div>
  </mat-card>
</ng-template>
